export function ChevronRightIcon({ className }: { className?: string }) {
  return (
    <div style={{ padding: "4px" }}>
      <svg
        className={className}
        width="16"
        height="16"
        viewBox="0 0 7 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.27593 4.87593C6.4634 5.06346 6.56872 5.31776 6.56872 5.58293C6.56872 5.84809 6.4634 6.1024 6.27593 6.28993L1.68293 10.8829C1.49664 11.0655 1.24583 11.1672 0.985 11.1658C0.724171 11.1645 0.4744 11.0603 0.289964 10.8759C0.105528 10.6915 0.00132999 10.4417 1.26439e-05 10.1809C-0.00130471 9.92003 0.100365 9.66922 0.282929 9.48293L4.18293 5.58293L0.282929 1.68293C0.100365 1.49664 -0.00130471 1.24583 1.26439e-05 0.985C0.00132999 0.724171 0.105528 0.4744 0.289964 0.289964C0.4744 0.105528 0.724171 0.00132999 0.985 1.26439e-05C1.24583 -0.00130471 1.49664 0.100365 1.68293 0.282929L6.27593 4.87593V4.87593Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
